import type { FaireProductEntity } from "../../entity_types/product";

export const p_jzbqeff2m6: FaireProductEntity = {
  token: "p_jzbqeff2m6",
  type: "product",
  name: "Squishy Night Lights - Bunny Zoo Animal Toddler Gift",
  brandToken: "b_7obrop9nhx",
  brandName: "Calla Products",
  imageUrl:
    "https://cdn.faire.com/fastly/91db66d68a349c015bb61da3c4867b6a765dea383406424dd56f6326afb671d6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0c6c75310bd7a4c84ab5793d5fe2050c88409adaffa94cfbabe6f92b128a55cf.jpeg",
    "https://cdn.faire.com/fastly/56a51ddd24e24b32c5d6f8695031a251f97f47dcd237bcbbb93c9f8206c94fd8.jpeg",
  ],
  priceDollars: 10,
  description:
    "Cutest nightlights in animal shapes, squishy toy for Fall and back to school. Different from Needoh squishy toys. Made with silicon; they are soft and squishy. Perfect for Easter, Spring and Fall gifts. Powered by USB-C cables, they change color when you pat the squishy light on the head. Timed to fade out as you fall asleep. Great decoration for desk, office, bedroom. Whimsical, cute, and appealing to everyone of every age, this squishy light is the best gift for any occasion. ",
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:39.185Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
